"use client";

import dynamic from "next/dynamic";
import React, { useState } from "react";
const TECollapse = dynamic(() =>
  import("tw-elements-react").then((res) => res.TECollapse)
);
function MianAccordion({
  items,
  color = "",
}: MianAccordionPropsType): JSX.Element {
  const [activeElement, setActiveElement] = useState<number>();

  const handleClick = (value: number) => {
    if (value === activeElement) {
      setActiveElement(undefined);
    } else {
      setActiveElement(value);
    }
  };

  return (
    <>
      {items.map((item, index) => (
        <div
          key={index}
          id={`accordion-${index}`}
          className="lg:rounded-[20px] relative my-8 rounded-[14px] shadow-cardLg bg-white text-primary"
        >
          <h2
            className="mb-0 lg:text-[1.5rem] text-[12px] font-semibold"
            id={`heading-${index}`}
          >
            <button
              className={` group relative flex w-full items-center min-h-[48px] px-5 py-4 `}
              type="button"
              onClick={() => handleClick(index)}
              aria-expanded={activeElement === index}
              aria-controls={`collapse-${index}`}
            >
              <span
                style={{ background: color || item.color }}
                className={`${
                  activeElement === index ? `rotate-180` : `rotate-90   `
                } h-[32px] w-[32px] lg:me-3 me-[12px] lg:h-[40px] lg:w-[40px] flex items-center justify-center ${
                  activeElement === index && color && "!bg-[#F2E30C]"
                } bg-orange rounded-full shrink-0  transition-transform duration-100 ease-in-out motion-reduce:transition-none `}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="15.109"
                  height="8.377"
                  viewBox="0 0 15.109 8.377"
                >
                  <path
                    id="Path_49625"
                    data-name="Path 49625"
                    d="M-14235-22930l5.834,5.359,5.742-5.359"
                    transform="translate(-14221.657 -22923.391) rotate(180)"
                    fill="none"
                    stroke="#fff"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2.5"
                  />
                </svg>
              </span>
              {item.title}
            </button>
          </h2>
          <TECollapse
            show={activeElement == index}
            className="!mt-0 relative !shadow-none block transition-all  ease-in duration-300"
            id={`collapse-${index}`}
            aria-labelledby={`heading-${index}`}
          >
            <div className="px-[4rem]  transition-shadow  py-[2rem] lg:ps-[4rem] ps-[43px]  lg:text-[1.25rem] text-[12px]">
              {item.body}
            </div>
          </TECollapse>
          <div
            style={{ background: color || item.color }}
            className={` absolute -z-10 top-[28%] left-[-1%] w-[102%] h-[77%] bg-orangeLight transition-all  ease-in duration-100 rounded-[20px] ${
              activeElement !== index && " opacity-0 "
            }`}
          ></div>
        </div>
      ))}
    </>
  );
}
export default MianAccordion;
type MianAccordionPropsType = {
  items: {
    title?: string | JSX.Element;
    body?: string | JSX.Element;
    color?: string;
  }[];
  color?: string;
};
